import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage } from '@/features/account/pages/overview-page'

/** A7 — Workspace overview / home. */
export const Route = createFileRoute('/_ws/w/$workspaceId/overview')({
  component: OverviewPage,
})
